import { LineStyle } from '../../../models/styling';

/**
 * Input for Route configuration map preview content
 */
export class McRoute {

  constructor(
    public id: number,
    public styleOverride: LineStyle,
    public visible: boolean,
  ) {}
}
